import { render, staticRenderFns } from "./addMedicalTemplate.vue?vue&type=template&id=51c282d4&scoped=true&"
import script from "./addMedicalTemplate.vue?vue&type=script&lang=js&"
export * from "./addMedicalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c282d4",
  null
  
)

export default component.exports